// Helpers
import { accountFormat } from "@/Common/helpers/number";
import { Nullable } from "@/Common/interfaces/types";
import { IUser } from "@/Common/interfaces/user";
import { TooltipTitleWrapper, TypographyCell } from "@/Layouts/components/Tables/DataSmartTable/additional/TypographyCell";

// Types
import { GridCellParams } from "@mui/x-data-grid-pro";
import { CompensationTooltipProps } from "./types";

const getTooltipTitle = (tooltip: boolean, user: Nullable<IUser>, params: Nullable<GridCellParams>) => {
	const show = tooltip && params?.id !== "auto-generated-group-footer-root" && params?.row?.item !== "Commission Subtotal";
	const { commission, originalCommission, modifiedBy } = params?.row || {};
	const isDifferentCommission = Boolean(commission !== originalCommission);
	if (show && isDifferentCommission) {
		const modified = modifiedBy || user?.fullName;
		return (
			<>
				<TooltipTitleWrapper text={`Modified by ${modified}`} />
				<TooltipTitleWrapper text={`Original commission: $${accountFormat(originalCommission)}`} />
			</>
		);
	}
	return null;
};

export default function CompensationTooltip(props: Readonly<CompensationTooltipProps>) {
	const { tooltip = true, isNegative = false, showValue = "", user = null, params } = props;
	const tooltipTitle = getTooltipTitle(tooltip, user, params);
	return (
		<TypographyCell
			tooltipProps={{
				arrow: true,
				title: tooltipTitle,
			}}
			forceTooltip={Boolean(tooltipTitle)}
			fontSize="14px"
			fontLineHeight="22px"
			params={params}
			noWrap
			hints={{ ...props.hints, isNegative }}
		>
			{isNegative ? `(${showValue})` : showValue}
		</TypographyCell>
	);
}
